// assets
import { IconBrandYoutube, IconFile, IconNews } from '@tabler/icons';
import { createChildGroupMenuItem, createChildMenuItem, createMenuItem } from 'utils/menu';

// ==============================|| LEARNING MENU ITEMS ||============================== //

const learning = [
  createMenuItem('pilgan', 'pilgan.read', 'Pilihan Ganda', '/learning/latihan/pilgan', IconNews, false),
  createMenuItem('pilgankompleks', 'pilgankompleks.read', 'Pilihan Ganda Kompleks', '/learning/latihan/pilgankompleks', IconNews, false),
  createMenuItem('essay', 'essay.read', 'Essay', '/learning/latihan/essay', IconNews, false),
  createMenuItem('hafalan', 'hafalan.read', 'Hafalan', '/learning/latihan/hafalan', IconNews, false),
  createMenuItem('rangkata', 'rangkata.read', 'Rangkai Kata', '/learning/latihan/rangkata', IconNews, false),
  createMenuItem('matchword', 'matchword.read', 'Matching Words', '/learning/matchword', IconNews, false),
  createMenuItem('japen', 'japen.read', 'Jawaban Pendek', '/learning/latihan/japen', IconNews, false),
  createMenuItem('video', 'video.read', 'Video Belajar', '/learning/video', IconBrandYoutube, false),
  createMenuItem('materi', 'materi.read', 'Rangkuman Materi', '/learning/materi', IconFile, false),
  createMenuItem('studywithme', 'studywithme.read', 'Study With Me', '/learning/studywithme', IconNews, false),
  createMenuItem('examarch', 'examarch.read', 'Soal Tahun Lalu', '/learning/examarch', IconNews, false)
];

const children = [
  {
    id: 'learning',
    title: 'Learning',
    type: 'collapse',
    icon: IconNews,
    children: createChildMenuItem(learning)
  }
];

const data = {
  id: 'learning',
  title: '',
  type: 'group',
  children: createChildGroupMenuItem(children)
};

export default data;
